import get from 'hs-lodash/get';
import merge from 'hs-lodash/merge';
const getStorageItemAsObject = storage => topLevelKey => {
  try {
    return JSON.parse(storage.getItem(topLevelKey) || '');
  } catch (e) {
    return null;
  }
};
const getInStorageItemAsObject = storage => topLevelKey => (path, defaultValue) => {
  const item = getStorageItemAsObject(storage)(topLevelKey) || {};
  return get(item, path, defaultValue);
};
const setInStorage = storage => (topLevelKey, value) => {
  try {
    storage.setItem(topLevelKey, JSON.stringify(value));
  } catch (e) {
    return;
  }
};
const mergeIntoStorage = storage => topLevelKey => value => {
  const item = getStorageItemAsObject(storage)(topLevelKey) || {};
  try {
    storage.setItem(topLevelKey, JSON.stringify(merge(item, value)));
  } catch (e) {
    return;
  }
};

/*
 * localStorage
 */
export const getLocalStorageAsObject = getStorageItemAsObject(localStorage);
export const getFromLocalStorage = getInStorageItemAsObject(localStorage);
export const setInLocalStorage = setInStorage(localStorage);
export const mergeIntoLocalStorage = mergeIntoStorage(localStorage);

/*
 * sessionStorage
 */
export const getSessionStorageAsObject = getStorageItemAsObject(sessionStorage);
export const getFromSessionStorage = getInStorageItemAsObject(sessionStorage);
export const setInSessionStorage = setInStorage(sessionStorage);
export const mergeIntoSessionStorage = mergeIntoStorage(sessionStorage);

/*
 * Cookies
 */
export const getCookie = name => {
  const value = `; ${document.cookie}`;
  const splitCookies = value.split(';');
  for (let i = 0; i < splitCookies.length; i++) {
    const parts = splitCookies[i].split('=');
    if (parts.length === 2 && parts[0].trim() === name) {
      return parts[1];
    }
  }
  return null;
};
export const setCookie = (name, value, daysActive = 30) => {
  let expirationDate = new Date();
  expirationDate = new Date(expirationDate.setDate(expirationDate.getDate() + daysActive));
  document.cookie = `${name}=${escape(value)};expires=${expirationDate.toUTCString()};domain=${window.location.host};path=/`;
};